// WCAG-rettelser i produktbeskrivelser (HTML fra data, ikke temaet):
// 4.1.2 – div/span med aria-label men uden rolle får role="img" (fx KW-bjælker "3 ud af 6") eller "group" hvis de rummer links.
// 2.1.1 – vandret scrollbare lister uden fokuserbart indhold (fx KW-feature-rækker på mobil) kan nås med tastatur.
(function () {
  function run() {
    document.querySelectorAll('.rte div[aria-label]:not([role]), .rte span[aria-label]:not([role])').forEach(function (el) {
      // Indeholder elementet links/knapper, er det en gruppe – ellers et billede (fx bjælke "3 ud af 6").
      el.setAttribute('role', el.querySelector('a[href], button, input, select, textarea, [tabindex]') ? 'group' : 'img');
    });
    document.querySelectorAll('.rte ul, .rte ol, .rte div').forEach(function (el) {
      if (el.hasAttribute('tabindex') || el.scrollWidth <= el.clientWidth + 2) return;
      if (!/(auto|scroll)/.test(getComputedStyle(el).overflowX)) return;
      if (el.querySelector('a[href], button, input, select, textarea, [tabindex]')) return;
      el.tabIndex = 0;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
}());
